import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useOthersStore } from "../../store/othersStore.js";
import { Input, message } from "antd";

import { PrimaryButton, VioletButtonLarge } from "../../components/button";

const { TextArea } = Input;

const CategoryDetails = () => {
  const location = useLocation();
  const { category, getCategory, updateCategory, getCategories } =
    useOthersStore();

  const id = location?.pathname?.split("/")[2];

  const [state, setState] = useState({
    title: "",
    name: "",
    description: "",
    metaTitle: "",
    metaDescription: "",
    slug: "",
  });
  useEffect(() => {
    fetchCategory();
  }, [id]);

  useEffect(() => {
    setState({
      title: category?.title ?? "",
      name: category?.name ?? "",
      description: category?.description ?? "",
      metaTitle: category?.metaTitle ?? "",
      metaDescription: category?.metaDescription ?? "",
      slug: category?.slug ?? "",
    });
  }, [category]);

  const fetchCategory = async () => {
    getCategory({ id });
  };

  const handleSubmit = () => {
    const requiredFields = [
      state?.title,
      state?.name,
      state?.description,
      state?.metaTitle,
      state?.metaDescription,
      state?.slug,
    ];

    const isValid = requiredFields.every(
      (field) => field && (field?.length > 0 || field.trim() !== "")
    );

    if (!isValid) {
      message.error("Please fill all the required fields");
      return;
    }

    const payload = {
      id: id,
      data: state,
    };

    console.log("Payload to Submit:", payload);
    updateCategory(payload, (res) => {
      if (res.status === 200) {
        getCategories({});
      }
    });
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <div>Slug *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Slug"
            onChange={(e) => setState({ ...state, slug: e.target.value })}
            value={state.slug}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Title *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Category title"
            onChange={(e) =>
              setState({
                ...state,
                name: e.target.value,
                title: e.target.value,
              })
            }
            value={state.title}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Meta Title *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Meta title"
            onChange={(e) => setState({ ...state, metaTitle: e.target.value })}
            value={state.metaTitle}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Description *</div>

          <TextArea
            rows={4}
            className="moneyPage"
            placeholder="Description"
            onChange={(e) =>
              setState({ ...state, description: e.target.value })
            }
            value={state.description}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Meta Description *</div>

          <TextArea
            rows={4}
            className="moneyPage"
            placeholder="Meta Description"
            onChange={(e) =>
              setState({ ...state, metaDescription: e.target.value })
            }
            value={state.metaDescription}
          />
        </div>
      </div>

      <div className="flex gap-3 items-center">
        <PrimaryButton
          text="Save"
          style={{ width: "200px" }}
          onClick={handleSubmit}
        />
        <VioletButtonLarge
          text="Cancel"
          style={{ width: "200px" }}
          onClick={() => window.history.back()}
        />
      </div>
    </div>
  );
};

export default CategoryDetails;








